<template>
    <el-popover placement="bottom" width="420" trigger="click" v-model="visible">
        <div class="currency-converter">
            <el-form  size="small">
                <!-- 源金额 + 源币种 -->
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="金额">
                            <el-input-number v-model="amountFrom" :precision="4" :min="0" controls-position="right"
                                style="width:100%" @change="calcTo" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="币种">
                            <el-select v-model="currencyFrom" filterable style="width:100%" @change="calcTo">
                                <el-option v-for="c in currencies" :key="c" :label="`${c} (${names[c] || c})`"
                                    :value="c" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 交换箭头 -->
                <div style="text-align:center;margin:10px 0;">
                    <i class="el-icon-sort" style="font-size:22px;color:#c0c4cc"></i>
                </div>

                <!-- 目标金额 + 目标币种 -->
                <el-row :gutter="16">
                    <el-col :span="12">
                        <el-form-item label="金额">
                            <el-input-number v-model="amountTo" :precision="4" :min="0" controls-position="right"
                                style="width:100%" @change="calcFrom" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="币种">
                            <el-select v-model="currencyTo" filterable style="width:100%" @change="calcFrom">
                                <el-option v-for="c in currencies" :key="c" :label="`${c} (${names[c] || c})`"
                                    :value="c" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 日期 -->
                <el-row :gutter="16" >
                    <el-col :span="24" style="margin-top:10px">
                        <el-form-item label="日期" style="margin-top:10px 0">
                            <el-date-picker v-model="date" type="date" placeholder="默认最新汇率" style="width:100%"
                                value-format="yyyy-MM-dd"
                                :picker-options="{ disabledDate: t => t.getTime() > Date.now() }" @change="calcTo" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <!-- 触发按钮 -->
        <el-button slot="reference" >汇率</el-button>
    </el-popover>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            visible: false,
            amountFrom: 1,
            currencyFrom: 'USD',
            amountTo: null,
            currencyTo: 'CNY',
            date: null, // null = latest

            currencies: ['USD', 'EUR', 'CNY', 'JPY', 'GBP', 'AUD', 'CAD', 'CHF', 'HKD', 'SGD', 'KRW', 'INR', 'RUB', 'BRL', 'TRY', 'MXN', 'THB', 'IDR', 'PHP', 'MYR', 'NZD', 'SEK', 'NOK'],
            names: {
                USD: '美元', EUR: '欧元', CNY: '人民币', JPY: '日元', GBP: '英镑',
                AUD: '澳元', CAD: '加元', CHF: '瑞士法郎', HKD: '港元', SGD: '新加坡元'
            },

            // 缓存最近一次成功的汇率，减少重复请求
            lastRate: null, // 1 currencyFrom = ? currencyTo
            lastKey: ''
        }
    },
    watch: {
        date() { this.calcTo() },
        currencyFrom() { this.calcTo() },
        currencyTo() { this.calcTo() }
    },
    methods: {
        // 防抖
        debounce(fn) {
            let timer
            return function () {
                clearTimeout(timer)
                timer = setTimeout(() => fn.apply(this), 300)
            }
        },

        // 正向计算：from → to
        calcTo: (function () {
            let running = false
            return async function () {
                if (running) return
                running = true
                this.debounce(async () => {
                    if (!this.amountFrom || this.amountFrom <= 0) {
                        this.amountTo = null
                        running = false
                        return
                    }
                    const rate = await this.getRate()
                    this.amountTo = this.amountFrom * rate
                    running = false
                })()
            }
        })(),

        // 反向计算：to → from
        calcFrom: (function () {
            let running = false
            return async function () {
                if (running) return
                running = true
                this.debounce(async () => {
                    if (!this.amountTo || this.amountTo <= 0) {
                        this.amountFrom = null
                        running = false
                        return
                    }
                    const rate = await this.getRate()
                    this.amountFrom = this.amountTo / rate
                    running = false
                })()
            }
        })(),

        // 获取当前汇率（带缓存）
        async getRate() {
            if (this.currencyFrom === this.currencyTo) return 1

            const key = `${this.currencyFrom}-${this.currencyTo}-${this.date || 'latest'}`
            if (this.lastKey === key && this.lastRate !== null) {
                return this.lastRate
            }

            try {
                const dateStr = this.date || 'latest'
                const { data } = await axios.get(`https://api.frankfurter.app/${dateStr}`, {
                    params: { from: this.currencyFrom, to: this.currencyTo }
                })
                const rate = data.rates[this.currencyTo]
                if (rate) {
                    this.lastRate = rate
                    this.lastKey = key
                    return rate
                }
            } catch (e) {
                this.$message.error('汇率获取失败')
            }
            return 1
        }
    },

    created() {
        // 初始计算一次
        this.$nextTick(() => this.calcTo())
    }
}
</script>

<style scoped lang="scss">
.currency-converter {
    padding: 10px 0;
}
.el-form-item{
    display: flex;
    align-items: center;
    margin: 0;
}
/deep/ .el-form-item__label{
    white-space: nowrap;
}
</style>